import { gcalUrl } from "@clockwise/client-commons/src/constants/site";
import { Button } from "@clockwise/design-system";
import * as React from "react";
import { LogoHorizontal } from "../../components/logo";

export interface NavBarProps {
  primaryButtonText?: string;
  primaryButtonLink?: string;
  secondaryButtonText?: string;
  secondaryButtonLink?: string;
}

export const NavBar = ({
  primaryButtonText = "Go to Calendar",
  primaryButtonLink = gcalUrl,
  secondaryButtonText,
  secondaryButtonLink,
}: NavBarProps) => {
  return (
    <div className="cw-fixed cw-inset-0 cw-bottom-auto cw-z-10 cw-flex cw-items-center cw-h-20 cw-px-5 cw-py-2 cw-bg-default cw-border-0 cw-border-b cw-border-solid cw-border-default md:cw-shadow-md">
      <a className="cw-py-5 cw-flex-1">
        <LogoHorizontal className="cw-w-[172px]" />
      </a>
      <div className="cw-hidden sm:cw-flex cw-gap-4">
        {secondaryButtonText && secondaryButtonLink && (
          <Button
            size="large"
            onClick={() => {
              document.open(secondaryButtonLink, "_blank");
            }}
            variant="text"
          >
            {secondaryButtonText}
          </Button>
        )}
        <Button
          size="large"
          onClick={() => {
            document.open(primaryButtonLink, "_blank");
          }}
          sentiment="positive"
        >
          {primaryButtonText}
        </Button>
      </div>
    </div>
  );
};
